module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":"start test","buttonTitle":"Test with PageSpeed Insights","limitExceeded":"Request limit exceeded"},"ru":{"button":"начать тест","buttonTitle":"Протестировать в PageSpeed Insights","limitExceeded":"Превышен лимит запросов"}}')
  delete Component.options._Ctor
}
